import { createContext, useState } from 'react'

import { ItemResponseDTO } from '../../sdk/items/items.types'
import { sdk } from '../../services/sdk'

interface AuditItemsDataContext {
  items: ItemResponseDTO[]
  itemsCount: number

  actions: {
    fetchItems: (
      page?: number,
      limit?: number,
      search?: string,
    ) => Promise<void>
  }
}

interface AuditItemsdProviderProps {
  children: React.ReactNode
}

export const AuditItemsContext = createContext({} as AuditItemsDataContext)

export function AuditItemsProvider(props: AuditItemsdProviderProps) {
  const [items, setItems] = useState<ItemResponseDTO[]>([])
  const [itemsCount, setItemsCount] = useState<number>(0)

  const fetchItems = async (page?: number, limit?: number, search?: string) => {
    try {
      const response = await sdk.items.getCompleteItems(page, limit, search)

      setItems(response.data)
      setItemsCount(response.count)
    } catch (err) {
      setItems([])
      setItemsCount(0)
    }
  }

  return (
    <AuditItemsContext.Provider
      value={{
        items,
        itemsCount,
        actions: {
          fetchItems,
        },
      }}
    >
      {props.children}
    </AuditItemsContext.Provider>
  )
}
